export const EVENT_CATEGORIES = {
  LIBROS: { label: "Libros", short: "Presentación de libro" },
  POESIA: { label: "Poesía", short: "Recital de poesía" },
  CHARLAS: { label: "Charlas", short: "Charla / conferencia" },
  TALLERES: { label: "Talleres", short: "Taller / club de lectura" },
  CUENTACUENTOS: { label: "Cuentacuentos", short: "Cuentacuentos" },
  OTRO: { label: "Otros", short: "Evento cultural" },
} as const;

export type EventCategoryKey = keyof typeof EVENT_CATEGORIES;

export const EVENT_TYPES = {
  PRESENTACION: "Presentación",
  FIRMA_LIBROS: "Firma de libros",
  COLOQUIO: "Coloquio",
  RECITAL: "Recital",
  TALLER: "Taller",
  FERIA: "Feria",
  CLUB_LECTURA: "Club de lectura",
  MESA_REDONDA: "Mesa redonda",
  INFANTIL: "Infantil",
  OTRO: "Otro",
} as const;

export type EventTypeKey = keyof typeof EVENT_TYPES;

export const AUDIENCE_TYPES = {
  TODOS_PUBLICOS: "Todos los públicos",
  ADULTOS: "Adultos",
  INFANTIL: "Infantil",
  JUVENIL: "Juvenil",
} as const;

export type AudienceTypeKey = keyof typeof AUDIENCE_TYPES;

export const ORGANIZATION_TYPES = [
  "Librería",
  "Biblioteca",
  "Universidad",
  "Editorial",
  "Asociación cultural",
  "Otro",
] as const;
